import type { Article } from '../types/showcase';

const site = 'https://buildersshowcaseofhomes.com';

export const articles: Article[] = [
  {
    id: 'innovation-excellence',
    title: 'Celebrating innovation and excellence in home design',
    excerpt:
      'Windward Construction – Azul. The Cape Coral Construction Industry Association (CCCIA) proudly announces the 29th annual Builders’ Showcase of Homes, presented by IncredibleBank, kicking off in January.',
    date: 'January 13, 2025',
    image: `${site}/wp-content/uploads/2024/01/Windward-2-768x512.jpg`,
    url: `${site}/celebrating-innovation-and-excellence-in-home-design/`,
  },
  {
    id: 'finest-builders',
    title: 'See Southwest Florida’s finest builders showcase their best',
    excerpt:
      'In the quest for the perfect home, navigating through the process can be both exhaustive and time-consuming. Recent estimates from Realtor.com suggest that the average homebuyer will visit 10 homes over 10 weeks before they find “the one.”',
    date: 'January 29, 2024',
    image: `${site}/wp-content/uploads/2024/01/4-STAGED-LANAI-768x512.jpg`,
    url: `${site}/see-southwest-floridas-finest-builders-showcase-their-best/`,
  },
  {
    id: 'moving-to-cape-coral',
    title: 'Moving to Cape Coral, FL: 10 reasons you’ll love living in Cape Coral',
    excerpt:
      'Are you considering a move to Cape Coral, FL? Here are ten things you need to know about living in Cape Coral, nestled in the scenic southwest region of Florida along the Gulf of Mexico.',
    date: 'October 7, 2023',
    image: `${site}/wp-content/uploads/2023/10/Cape-Coral-city-768x454.png`,
    url: `${site}/hello-world-2/`,
  },
  {
    id: 'gateway-dream-homes',
    title: 'CCCIA Builders’ Showcase of Homes presented by Koogler Homes: A gateway to Southwest Florida’s dream homes',
    excerpt:
      'In the quest for the perfect home, navigating through the process can be both exhaustive and time-consuming. The Showcase brings the region’s best builders together in one place.',
    date: 'October 7, 2023',
    image: `${site}/wp-content/uploads/2024/01/1003-NW-35th-Ave-Cape-Coral-FL-33993-1-768x512.jpg`,
    url: `${site}/one-thing-separates-creators-from-consumers/`,
  },
  {
    id: 'koogler-signature-series',
    title: 'Introducing the Koogler Signature Series: Discover the magic of Koogler Country',
    excerpt:
      'This winter we are proud to introduce our Koogler Signature series, featuring homes that start at 2,200 sf under air.',
    date: 'October 7, 2023',
    image: `${site}/wp-content/uploads/2024/01/CrownJewel-1-768x512.jpg`,
    url: `${site}/should-startups-care-about-profitability/`,
  },
];
